// Country dial codes for the Create-Card phone/WhatsApp picker.
// Small hand-curated set (60+) covering primary user regions. Not exhaustive.
// { iso: ISO-3166 alpha-2, name: English name, dial: international dial code, flag: emoji }

const COUNTRY_CODES = [
  { iso: "US", name: "United States", dial: "1", flag: "🇺🇸" },
  { iso: "CA", name: "Canada", dial: "1", flag: "🇨🇦" },
  { iso: "MX", name: "Mexico", dial: "52", flag: "🇲🇽" },
  { iso: "GB", name: "United Kingdom", dial: "44", flag: "🇬🇧" },
  { iso: "IE", name: "Ireland", dial: "353", flag: "🇮🇪" },
  { iso: "FR", name: "France", dial: "33", flag: "🇫🇷" },
  { iso: "DE", name: "Germany", dial: "49", flag: "🇩🇪" },
  { iso: "ES", name: "Spain", dial: "34", flag: "🇪🇸" },
  { iso: "IT", name: "Italy", dial: "39", flag: "🇮🇹" },
  { iso: "PT", name: "Portugal", dial: "351", flag: "🇵🇹" },
  { iso: "NL", name: "Netherlands", dial: "31", flag: "🇳🇱" },
  { iso: "BE", name: "Belgium", dial: "32", flag: "🇧🇪" },
  { iso: "CH", name: "Switzerland", dial: "41", flag: "🇨🇭" },
  { iso: "AT", name: "Austria", dial: "43", flag: "🇦🇹" },
  { iso: "SE", name: "Sweden", dial: "46", flag: "🇸🇪" },
  { iso: "NO", name: "Norway", dial: "47", flag: "🇳🇴" },
  { iso: "DK", name: "Denmark", dial: "45", flag: "🇩🇰" },
  { iso: "FI", name: "Finland", dial: "358", flag: "🇫🇮" },
  { iso: "PL", name: "Poland", dial: "48", flag: "🇵🇱" },
  { iso: "CZ", name: "Czechia", dial: "420", flag: "🇨🇿" },
  { iso: "HU", name: "Hungary", dial: "36", flag: "🇭🇺" },
  { iso: "RO", name: "Romania", dial: "40", flag: "🇷🇴" },
  { iso: "BG", name: "Bulgaria", dial: "359", flag: "🇧🇬" },
  { iso: "GR", name: "Greece", dial: "30", flag: "🇬🇷" },
  { iso: "TR", name: "Türkiye", dial: "90", flag: "🇹🇷" },
  { iso: "UA", name: "Ukraine", dial: "380", flag: "🇺🇦" },
  { iso: "RU", name: "Russia", dial: "7", flag: "🇷🇺" },
  { iso: "AE", name: "United Arab Emirates", dial: "971", flag: "🇦🇪" },
  { iso: "SA", name: "Saudi Arabia", dial: "966", flag: "🇸🇦" },
  { iso: "QA", name: "Qatar", dial: "974", flag: "🇶🇦" },
  { iso: "KW", name: "Kuwait", dial: "965", flag: "🇰🇼" },
  { iso: "BH", name: "Bahrain", dial: "973", flag: "🇧🇭" },
  { iso: "OM", name: "Oman", dial: "968", flag: "🇴🇲" },
  { iso: "JO", name: "Jordan", dial: "962", flag: "🇯🇴" },
  { iso: "LB", name: "Lebanon", dial: "961", flag: "🇱🇧" },
  { iso: "EG", name: "Egypt", dial: "20", flag: "🇪🇬" },
  { iso: "MA", name: "Morocco", dial: "212", flag: "🇲🇦" },
  { iso: "NG", name: "Nigeria", dial: "234", flag: "🇳🇬" },
  { iso: "ZA", name: "South Africa", dial: "27", flag: "🇿🇦" },
  { iso: "KE", name: "Kenya", dial: "254", flag: "🇰🇪" },
  { iso: "IN", name: "India", dial: "91", flag: "🇮🇳" },
  { iso: "PK", name: "Pakistan", dial: "92", flag: "🇵🇰" },
  { iso: "BD", name: "Bangladesh", dial: "880", flag: "🇧🇩" },
  { iso: "LK", name: "Sri Lanka", dial: "94", flag: "🇱🇰" },
  { iso: "CN", name: "China", dial: "86", flag: "🇨🇳" },
  { iso: "HK", name: "Hong Kong", dial: "852", flag: "🇭🇰" },
  { iso: "TW", name: "Taiwan", dial: "886", flag: "🇹🇼" },
  { iso: "JP", name: "Japan", dial: "81", flag: "🇯🇵" },
  { iso: "KR", name: "South Korea", dial: "82", flag: "🇰🇷" },
  { iso: "SG", name: "Singapore", dial: "65", flag: "🇸🇬" },
  { iso: "MY", name: "Malaysia", dial: "60", flag: "🇲🇾" },
  { iso: "TH", name: "Thailand", dial: "66", flag: "🇹🇭" },
  { iso: "ID", name: "Indonesia", dial: "62", flag: "🇮🇩" },
  { iso: "PH", name: "Philippines", dial: "63", flag: "🇵🇭" },
  { iso: "VN", name: "Vietnam", dial: "84", flag: "🇻🇳" },
  { iso: "AU", name: "Australia", dial: "61", flag: "🇦🇺" },
  { iso: "NZ", name: "New Zealand", dial: "64", flag: "🇳🇿" },
  { iso: "BR", name: "Brazil", dial: "55", flag: "🇧🇷" },
  { iso: "AR", name: "Argentina", dial: "54", flag: "🇦🇷" },
  { iso: "CL", name: "Chile", dial: "56", flag: "🇨🇱" },
  { iso: "CO", name: "Colombia", dial: "57", flag: "🇨🇴" },
  { iso: "PE", name: "Peru", dial: "51", flag: "🇵🇪" },
  { iso: "VE", name: "Venezuela", dial: "58", flag: "🇻🇪" },
];

export default COUNTRY_CODES;

// Match the longest matching dial code prefix so `+9715551234` picks AE (971)
// rather than the shorter US (1). Returns { iso, dial, flag, name } or null.
export function matchByDial(rawValue) {
  if (!rawValue || typeof rawValue !== "string") return null;
  const digits = rawValue.replace(/^\+/, "").replace(/[^0-9]/g, "");
  if (!digits) return null;
  const sorted = [...COUNTRY_CODES].sort((a, b) => b.dial.length - a.dial.length);
  for (const c of sorted) {
    if (digits.startsWith(c.dial)) return c;
  }
  return null;
}

// Return { country, national } given a stored `+{dial}{number}` string.
// If the string doesn't start with `+` or no country matches, returns
// { country: null, national: original }.
export function parsePhone(raw) {
  if (!raw || typeof raw !== "string") return { country: null, national: "" };
  if (!raw.trim().startsWith("+")) return { country: null, national: raw.trim() };
  const country = matchByDial(raw);
  if (!country) return { country: null, national: raw.trim() };
  const digits = raw.replace(/^\+/, "").replace(/[^0-9]/g, "");
  const national = digits.slice(country.dial.length);
  return { country, national };
}

export function findByIso(iso) {
  if (!iso) return null;
  const upper = String(iso).toUpperCase();
  return COUNTRY_CODES.find((c) => c.iso === upper) || null;
}

// ---------------------------------------------------------------------------
// Browser-side country detection (no backend, no geo-IP)
// Used by <PhoneInput/> when the parent doesn't pass an explicit country and
// the stored phone value doesn't already contain a dial prefix.
// ---------------------------------------------------------------------------

// Curated timezone → ISO-3166 alpha-2 map. Small on purpose (~40 zones) —
// covers the primary regions our users log in from. Anything unmapped falls
// through to the next detection step.
export const TIMEZONE_TO_ISO = {
  // Middle East
  "Asia/Dubai": "AE",
  "Asia/Muscat": "OM",
  "Asia/Qatar": "QA",
  "Asia/Bahrain": "BH",
  "Asia/Kuwait": "KW",
  "Asia/Riyadh": "SA",
  "Asia/Amman": "JO",
  "Asia/Beirut": "LB",
  // North America
  "America/New_York": "US",
  "America/Chicago": "US",
  "America/Denver": "US",
  "America/Los_Angeles": "US",
  "America/Phoenix": "US",
  "America/Anchorage": "US",
  "America/Toronto": "CA",
  "America/Vancouver": "CA",
  "America/Mexico_City": "MX",
  // Europe
  "Europe/London": "GB",
  "Europe/Dublin": "IE",
  "Europe/Paris": "FR",
  "Europe/Berlin": "DE",
  "Europe/Madrid": "ES",
  "Europe/Rome": "IT",
  "Europe/Amsterdam": "NL",
  "Europe/Brussels": "BE",
  "Europe/Zurich": "CH",
  "Europe/Vienna": "AT",
  "Europe/Stockholm": "SE",
  "Europe/Oslo": "NO",
  "Europe/Copenhagen": "DK",
  "Europe/Helsinki": "FI",
  "Europe/Warsaw": "PL",
  "Europe/Athens": "GR",
  "Europe/Istanbul": "TR",
  "Europe/Moscow": "RU",
  // Asia / Pacific
  "Asia/Kolkata": "IN",
  "Asia/Karachi": "PK",
  "Asia/Dhaka": "BD",
  "Asia/Colombo": "LK",
  "Asia/Shanghai": "CN",
  "Asia/Hong_Kong": "HK",
  "Asia/Taipei": "TW",
  "Asia/Tokyo": "JP",
  "Asia/Seoul": "KR",
  "Asia/Singapore": "SG",
  "Asia/Kuala_Lumpur": "MY",
  "Asia/Bangkok": "TH",
  "Asia/Jakarta": "ID",
  "Asia/Manila": "PH",
  "Asia/Ho_Chi_Minh": "VN",
  "Australia/Sydney": "AU",
  "Australia/Melbourne": "AU",
  "Pacific/Auckland": "NZ",
  // Africa
  "Africa/Cairo": "EG",
  "Africa/Casablanca": "MA",
  "Africa/Lagos": "NG",
  "Africa/Johannesburg": "ZA",
  "Africa/Nairobi": "KE",
  // Latin America
  "America/Sao_Paulo": "BR",
  "America/Argentina/Buenos_Aires": "AR",
  "America/Santiago": "CL",
  "America/Bogota": "CO",
  "America/Lima": "PE",
  "America/Caracas": "VE",
};

// Try `navigator.language` (e.g. "en-AE" → "AE"). Uses `Intl.Locale` when
// available; falls back to a regex split. Returns null if no region can be
// derived.
function isoFromLocale() {
  if (typeof navigator === "undefined") return null;
  const lang = navigator.language || (navigator.languages && navigator.languages[0]);
  if (!lang) return null;
  try {
    if (typeof Intl !== "undefined" && typeof Intl.Locale === "function") {
      const region = new Intl.Locale(lang).region;
      if (region && findByIso(region)) return region.toUpperCase();
    }
  } catch { /* ignore */ }
  // Fallback: split "en-AE" style tags.
  const parts = String(lang).split("-");
  if (parts.length >= 2) {
    const region = parts[parts.length - 1].toUpperCase();
    if (region.length === 2 && findByIso(region)) return region;
  }
  return null;
}

// Try `Intl.DateTimeFormat().resolvedOptions().timeZone` → look up in the map.
function isoFromTimezone() {
  if (typeof Intl === "undefined") return null;
  try {
    const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
    if (tz && TIMEZONE_TO_ISO[tz]) return TIMEZONE_TO_ISO[tz];
  } catch { /* ignore */ }
  return null;
}

/**
 * Resolve a best-guess ISO-3166 alpha-2 country code for the current browser.
 * Chain: explicit hint → navigator.language region → timezone map → "US".
 * Returns { iso, source, trace } where `trace` is the per-step resolution log
 * (useful for surfacing via console.log in <PhoneInput/>).
 */
export function detectBrowserCountryIso(explicitHint = "") {
  const fromProp = explicitHint && findByIso(explicitHint) ? String(explicitHint).toUpperCase() : null;
  const fromLocale = fromProp ? null : isoFromLocale();
  const fromTz = (fromProp || fromLocale) ? null : isoFromTimezone();
  const final = fromProp || fromLocale || fromTz || "US";
  const source = fromProp ? "prop" : fromLocale ? "locale" : fromTz ? "timezone" : "fallback";
  return { iso: final, source, trace: { fromProp, fromLocale, fromTz, final } };
}
